import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Button } from "../../ui/Button";
import LineTo, { SteppedLineTo } from "react-lineto";
import { lighterColor } from "../../utils/generateBackgroundColor";

interface IProps {
  cardData: any;
  linkData?: any;
  getConnections?: any;
}

const StrategymapCard = ({ cardData, linkData }: IProps) => {
  const RANGE = (x, y) =>
    Array.from(
      (function* () {
        while (x <= y) yield x++;
      })()
    );
  const position = RANGE(20, 90);
  const position2 = RANGE(20, 90);

  return (
    <Container className="container">
      {cardData.map((card: any) => {
        return (
          <StrategyMapCard
            className={`${card?.id}`}
            backgroundColor={lighterColor(card.color, 0.5)}
            color={card.color}
            key={card.id}
          >
            {card.name}
            <AddButton text="+" />
          </StrategyMapCard>
        );
      })}
      {linkData &&
        linkData.map((item) => {
          return (
            <SteppedLineTo
              from={`${item.id}`}
              to={`${item.pid}`}
              delay={0}
              fromAnchor={`${
                position[Math.floor(Math.random() * position.length)]
              }% ${position[Math.floor(Math.random() * position.length)]}%`}
              toAnchor={`${
                position2[Math.floor(Math.random() * position2.length)]
              }% ${position2[Math.floor(Math.random() * position2.length)]}%`}
              borderColor={item.color.color}
              borderWidth={2}
              className="connector"
            />
          );
        })}
    </Container>
  );
};

export default StrategymapCard;

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, 18.7em);
  background-color: #fff;
  border-radius: 0.5em;
  margin-top: 1em;
  margin-bottom: 1em;
  padding-top: 1em;
  /* padding-bottom: 1em; */
  height: 12.5rem;
  overflow-x: scroll;
`;
const AddButton = styled(Button)`
  position: absolute;
  padding: 0.5em 0.65em;
  border: none;
  border-radius: 0.5em;
  cursor: pointer;
  font-weight: bold;
  font-size: 1em;
  /* right: -10px; */
  right: 40%;
  bottom: -10px;
  display: none;
`;
const StrategyMapCard = styled.div<{
  backgroundColor?: string;
  color?: string;
}>`
  position: relative;
  align-items: center;
  background-color: ${(props) => props.backgroundColor || "#F5F6FB"};
  color: ${(props) => props.color || "#000"};
  padding: 3.5em 1em;
  margin: 0.5em 1em 0.5em 1em;
  border-radius: 1em;
  font-size: 14px;
  z-index: 99;
  &:hover {
    background-color: #fff;
    color: #000;
    box-shadow: 1px 5px 5px 5px rgba(55, 81, 255, 0.1);
    ${AddButton} {
      display: inline-block;
    }
  }
`;
